import { render, staticRenderFns } from "./RessifApexPieChart.vue?vue&type=template&id=59b6df54&"
import script from "./RessifApexPieChart.vue?vue&type=script&lang=ts&"
export * from "./RessifApexPieChart.vue?vue&type=script&lang=ts&"
import style0 from "./RessifApexPieChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports